import { MapMarker } from '@angular/google-maps';
import { MediaModel } from './media.model';
import { PropertyLocationModel } from './property.model';

export class PropertyListModel {
  Id: number = 0;
  Name?: string;
  Url?: string;
  LongUrl?: string;
  Address?: string;
  City?: string;
  OverallRating?: number;
  NumberOfReviews?: number;
  Description?: string;
  ShortDescription?: string;
  TopMedia?: MediaModel;
  Longitude?: number;
  Latitude?: number;
  MapPos?: google.maps.LatLngLiteral;
  MapMarker?: MapMarker;
  IsWithinBounds: boolean = false;
  Rating: number = 0;
  RatingScore: number = 0;
  DistanceFromCenter: number = 0;
  SearchFilters: number[] = [];

  Location: PropertyLocationModel = new PropertyLocationModel();
}
